import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { useUser } from "@/libs/auth/data/user";
import { UserIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LanguageSelector } from "./LanguageSelector";

export function ProfileSidebar({ name }: { name?: string }) {
  const { t } = useTranslation();

  const { logout } = useUser();

  return (
    <Sheet>
      <SheetTrigger className="cursor-pointer">
        <div className="bg-slate-500 border-2 border-slate-600 w-12 h-12 grid place-items-center rounded-full">
          <UserIcon className="text-white w-6 h-6" />
        </div>
      </SheetTrigger>
      <SheetContent
        side="left"
        className="flex-1 justify-between flex flex-col"
      >
        <SheetHeader>
          <SheetTitle>{name}</SheetTitle>
        </SheetHeader>

        <SheetFooter className="w-full">
          <div className="flex flex-col w-full gap-3">
            <LanguageSelector />

            <Button className="w-full" variant="destructive" onClick={logout}>
              {t("login.logout")}
            </Button>
            <p className="text-center text-slate-400 mt-4">v2.2.2</p>
          </div>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
